import { render, staticRenderFns } from "./TextToSpeech.vue?vue&type=template&id=592397fb"
import script from "./TextToSpeech.vue?vue&type=script&lang=ts"
export * from "./TextToSpeech.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports